import SelectionState from "state/selections/SelectionState";
import SummaryType from "state/selections/Constants/SummaryType";
import { titleCase } from "@ls/js-utils";
import {
  selectDefinitions,
  selectFetchingData,
} from "state/perfReturns/selectors";
import { deleteColumn } from "state/grid/actions";
import { useDispatch, useSelector } from "react-redux";
import React from "react";

export const useColumnDefinitions = () => {
  const selectedPerfReturnDefinitions = useSelector(
    selectDefinitions(SelectionState.COMMITTED)
  );
  const fetchingAbsData = useSelector(selectFetchingData(SummaryType.ABSOLUTE));
  const dispatch = useDispatch();
  const fetchingRelData = useSelector(selectFetchingData(SummaryType.RELATIVE));
  return React.useMemo(() => {
    return selectedPerfReturnDefinitions.map((definition) => {
      const { type, summary } = definition;
      return {
        headerName: titleCase(type) + ", " + titleCase(summary),
        field: `${type},${summary}`,
        colId: `${type},${summary}`,
        loading:
          (summary === SummaryType.ABSOLUTE && fetchingAbsData) ||
          (summary === SummaryType.RELATIVE && fetchingRelData),
        X_onDelete: () => dispatch(deleteColumn(definition)),
      };
    });
  }, [
    dispatch,
    fetchingAbsData,
    fetchingRelData,
    selectedPerfReturnDefinitions,
  ]);
};
